<div [insideClick]="true" class="dropdown d-inline-block" dropdown>

  <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" dropdownToggle>
    <i class="bx bx-bell " [class.bx-tada]="(notificationTasksService.notificationUnReadCountSubject |async) > 0"></i>
    <span *ngIf="(notificationTasksService.notificationUnReadCountSubject |async) as unreadCount"
      class="badge bg-danger rounded-pill">
      {{unreadCount}}
    </span>
  </button>

  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown"
    *dropdownMenu>

    <!-- Notification Type Selector -->
    <div class="p-3">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="m-0">Notification</h6>
        </div>

        <div class="col-auto">
          <a *ngIf="notificationTasksService.notificationUnReadCountSubject |async" type="button"
            (click)="markNotificationTaskReadAll()" class="btn btn-sm text-success">Mark read
            ({{(notificationTasksService.notificationUnReadCountSubject
            |async)}})</a>
          <a [routerLink]="['/notification/settings']" class="small">Settings</a>
        </div>
      </div>
    </div>

    <ng-container *ngIf="(unreadTasks$|async) as tasks">
      <ng-container *ngIf="tasks.length ; else noData">
        <ngx-simplebar style="position: relative; height: 230px;">
          <div class="text-reset notification-item" *ngFor="let task of tasks;let dayIndex=index">
            <!-- Notification -->
            <div class="text-reset notification-item">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-12 text-muted">
                    <h6> {{ task.messageContent }}</h6>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      <span *ngIf="task.taskDateTime as taskDateStr">
                        {{ taskDateStr | timeago}}
                      </span>
                      <a *ngIf="!task.isViewed" (click)="markAsRead(task)" type="button"
                        class="btn btn-link btn-sm">Mark
                        read</a>
                    </p>
                  </div>
                </div>
                <div>
                  <a class="mb-1" *ngIf="task.taskLink" [href]="task.taskLink" target="_blank">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ngx-simplebar>
        <div class="p-2 border-top d-grid">
          <a class="btn btn-sm btn-link font-size-14 text-center" [routerLink]="['/notification']">
            <i class="mdi mdi-arrow-right-circle me-1"></i>
            <span key="t-view-more">View All</span>
          </a>
        </div>
      </ng-container>

      <ng-template #noData>
        <div class="text-reset notification-item">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="font-size-12 text-muted">
                <p class="mb-1">
                  No notifications available.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>


  </div>
</div>